import { getHeaders, getMXIEndpoint } from "../../../helpers/endpoint";

export const REQUEST_MXI_CHAMPIONSHIP_PLAYERS_POOL = 'REQUEST_MXI_CHAMPIONSHIP_PLAYERS_POOL';
export const SUCCESS_MXI_CHAMPIONSHIP_PLAYERS_POOL = 'SUCCESS_MXI_CHAMPIONSHIP_PLAYERS_POOL';
export const FAIL_MXI_CHAMPIONSHIP_PLAYERS_POOL = 'FAIL_MXI_CHAMPIONSHIP_PLAYERS_POOL';

export const getChampionshipPlayerPool = (payload, scope, callBacks) => {
  return (dispatch, getState) => {
    if (callBacks?.onRequest) {
      callBacks.onRequest();
    }
    dispatch({type: REQUEST_MXI_CHAMPIONSHIP_PLAYERS_POOL, payload, scope});

    fetch(getMXIEndpoint('getMXIChampionshipPlayerPool', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (callBacks?.onError) {
            callBacks.onError();
          }
          dispatch({
            type: FAIL_MXI_CHAMPIONSHIP_PLAYERS_POOL,
            error: data.error,
            payload,
            scope,
          });
        } else {
          if (callBacks?.onSuccess) {
            callBacks.onSuccess(data);
          }
          dispatch(successChampionshipCalendar(data, payload, scope));
        }
      })
      .catch((error, type = FAIL_MXI_CHAMPIONSHIP_PLAYERS_POOL) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successChampionshipCalendar(response, payload, scope) {
  return dispatch => {
    dispatch({
      type: SUCCESS_MXI_CHAMPIONSHIP_PLAYERS_POOL,
      receivedAt: Date.now(),
      success: response.success,
      response,
      payload,
      scope,
    });
  };
}


// WEBPACK FOOTER //
// ./src/actions/entities/mxi/championshipPlayerPool.js